export const MAX_ARCHIVE_SEARCH_QUERY_LENGTH = 100;

export function normalizeArchiveSearchQuery(value: string): string {
  return value.trim().slice(0, MAX_ARCHIVE_SEARCH_QUERY_LENGTH);
}
